import React, { useState } from "react";
import { TiTick } from "react-icons/ti";
import CMSDevelopmentSideImage from "../../assets/images/Mockup-of-CMS-Website-developed-by-Apptalyst.avif";
import BannerSideImage from "../../assets/images/adding-widget-on-a-CMS.webp";
import BannerImage from "@assets/images/Web-Designing.webp"; 
import "../../App.css";
import CustomBanner from "../../components/CustomBanner";
import FAQSection from "../../components/FAQSection";
import { faqData } from "./CMSDevelopmentData";
import { motion } from "framer-motion";
import { IndustriesAndProfessionalWeServe } from "./components/IndustriesAndProfessionalWeServe/index.jsx";
import { LookingToLaunchWebsite } from "./components/LookingToLaunchWebsite/index.jsx";
import { Head } from "vite-react-ssg";
import FrostedContainer from "../../components/FrostedContainer/index.jsx";
import { TopCMSPlatforms } from "./components/TopCMSPlatforms/index.jsx";

const CMSDevelopment = () => {
  return (
    <>
      <Head>
        <title>Top CMS Website Development Company for Small Businesses in VA</title>
        <meta
          name="description"
          content="Expert CMS web design & development for small businesses in Virginia, US. We provide high-performance, responsive websites to help your brand grow fast."
        />
        <link rel="canonical" href="https://apptalyst.com/cms-development" />
      </Head>
      <CustomBanner
        bgImg={BannerImage} 
                    customHeight={true}
        // svgWidth="w-[11rem] mobSmallScreen:w-[13rem]  mobMediumScreen:w-[16rem] screen-400:w-[17rem] mobileLargeScreen:w-[18rem] xs:w-[20rem] sm:w-[20rem] md:w-[21rem] lg:w-[23rem] xl:w-[25rem]"
        // svgPosition="-bottom-20  mobileLargeScreen:-bottom-[5rem] md:top-[67%]  lg:top-[64%]   xl:top-[60%]  "
        // svgImg={BannerSideImage}
        // imgAlt="A person easily placing a widget on a CMS-based website with other objects such as images and navigation."
      >
      <FrostedContainer>

          <motion.h1 
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px] leading-[1]  font-bold "
          >
            CMS Web Development for Small Businesses in Virginia and all across
            US{" "}
          </motion.h1>
          <div className="space-y-4">
            <p className="text-base leading-[1.625rem] font-semibold text-white ">
              In the world of web design, CMS stands for Content Management
              System. A CMS is an online software application that allows you to
              create, manage, and modify content on a website without any coding
              expertise. Instead of relying on a developer for every minor
              update, a CMS provides a user-friendly interface which gives you
              total control over your website.
            </p>
            <p className="text-base leading-[1.625rem] font-semibold text-white ">
              At Apptalyst, we specialize in leveraging CMS development to help
              SMBs across Virginia and the US launch and scale their brands with
              confidence. By following web development best practices, we ensure
              your website looks professional and is fully-responsive on every
              device.
            </p>
          </div>
      </FrostedContainer>

      </CustomBanner>
      <section className=" space-y-20 md:space-y-32 mb-20 md:mb-32 mt-32 ">


      <section className="container space-y-20 md:space-y-32 ">
        <div className="flex flex-col  space-y-10   justify-center items-center  ">
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12  ">
     
          <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold text-center  text-dark font-butler"
            >
              The Benefits of CMS Websites for Small Businesses{" "}
            </motion.h2>
              </div>
<div className="flex flex-col xl:flex-row space-y-10 xl:space-y-0  xl:space-x-8 sm:px-10 justify-center items-center  lg:px-0">
          <div className="space-y-10 w-full xl:w-7/12 ">
            

            <ul className="space-y-2 text-lg">
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      Complete Content Control:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      Easily update text, swap images, and manage products
                      instantly without prior technical knowledge.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      A Scalable Business Engine:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      Beyond a simple landing page, a CMS can advertise
                      services, automate appointment bookings, and sell products
                      to online customers.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      Rapid Deployment for Startups:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      The quickest, most efficient web solutions for
                      informational or e-commerce websites.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      Seamless Third-Party Integrations:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      Easily expand your website’s capabilities. With readily
                      available widgets and plugins, integrate your site with
                      popular business tools.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      All-in-One Affordable Packages:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      Our packages include hosting, security, support, and all
                      the essentials needed to stay online and protected.
                    </p>
                  </div>
                </div>
              </li>
              <li className="flex items-start text-dark text-base md:text-lg space-x-2">
                <div className="flex items-start  md:items-start text-base md:text-lg">
                  <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                    <TiTick />
                  </span>
                  <div>
                    <p className="text-lg font-bold text-dark inline">
                      Post-Deployment Empowerment:{" "}
                    </p>
                    <p className="text-base leading-[1.625rem] text-dark inline">
                      Our expert CMS developers provide training sessions to
                      ensure you and your team are confident in managing your
                      new platform.
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div className="w-10/12 md:w-10/12 lg:w-8/12 xl:w-5/12 ">
            <img
              // loading='lazy'
              src={CMSDevelopmentSideImage}
              alt="A portfolio item for web development, a WordPress Website designed and maintained by Apptalyst."
              className="rounded w-full "
            />
          </div>
          </div>

        </div>

        <IndustriesAndProfessionalWeServe />
      </section>

      <LookingToLaunchWebsite />
     
<section className="container  space-y-20 md:space-y-32 ">

        <TopCMSPlatforms/>
        <FAQSection faqData={faqData} />
</section>
               </section>
    </>
  );
};

export default CMSDevelopment;
